import {AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {NgForm} from "@angular/forms";
import {MatPaginator, PageEvent} from "@angular/material/paginator";
import {ReceivablesImportRow} from "../../../../shared/interface/receivables-import-row";
import {ReplaySubject} from "rxjs";
import {UserPermissions} from "../../../../shared/interface/user-permissions";
import {InsuranceCompany} from "../../../../shared/interface/insurance-company";
import {ReceivablesStatement} from "../../../../shared/interface/receivables-statement";
import {MatDialog} from "@angular/material/dialog";
import {MatSnackBar} from "@angular/material/snack-bar";
import {AuthService} from "../../../../shared/services/auth.service";
import {FilterService} from "../../../../shared/services/filter.service";
import {ActivatedRoute, Router} from "@angular/router";
import {select, Store} from "@ngrx/store";
import {StoreRootState} from "../../../../shared/ngrx/reducers";
import {ReceivablesImportsRowService} from "../../../../shared/services/receivables-imports-row.service";
import {delay, distinctUntilChanged, first, takeUntil} from "rxjs/operators";
import {CountedAndPaginated} from "../../../../shared/interface/response/counted-and-paginated";
import {HttpErrorResponse} from "@angular/common/http";
import {getCurrentRouteState} from "../../../../shared/ngrx/selector";
import {RouterStateUrl} from "../../../../shared/ngrx/route-serializer";
import {ReceivablesStatementService} from "../../../../shared/services/receivables-statement.service";
import {Uuid} from "../../../../shared/interface/response/uuid";
import {JobResultDialogComponent} from "../../../../shared/components/job-result-dialog/job-result-dialog.component";

@Component({
  selector: 'app-all-receivables-statement-list',
  templateUrl: './all-receivables-statement-list.component.html',
  styleUrls: ['./all-receivables-statement-list.component.scss']
})
export class AllReceivablesStatementListComponent implements  AfterViewInit, OnInit, OnDestroy {
  @ViewChild('filtersForm') filtersForm: NgForm;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @Input() statusKey?: string[] = null;
  @Input() partnerId?: string =  null;
  @Input() showFilter = true;
  @Input()displayedColumns: string[] = [];
  @Input() embeddedView = false;
  @Input() receivablesBalanceId?: string = null;

  initialFilters: any;
  initialFiltersHistory: any;
  rows: ReceivablesStatement[] = [];
  totalData = 0;
  userPermissions: ReplaySubject<UserPermissions>;

  private destroyed$: ReplaySubject<boolean> = new ReplaySubject<boolean>(1);

  constructor(
    private dialog: MatDialog,
    private snack: MatSnackBar,
    private auth: AuthService,
    private filterService: FilterService,
    private activatedRoute: ActivatedRoute,
    private store: Store<StoreRootState>,
    private router: Router,
    private receivablesStatementService: ReceivablesStatementService,
  ) {
    this.userPermissions = auth.getUserPermissions();
    this.receivablesStatementService.receivablesStatementListSubject
      .pipe(
        takeUntil(this.destroyed$),
        delay(0)
      ).subscribe({
      next: (response: CountedAndPaginated<ReceivablesStatement>) => {
        this.rows = response.items;
        this.totalData = response.pagination.total;
      },
      error: (response: HttpErrorResponse) => {
        this.snack.open('Przy ładowaniu danych wystąpił błąd', response.status.toString(), {duration: 2000});
      }
    });
    this.parseFilters();
  }

  parseFilters(filters?: any): void {
    this.initialFilters = this.filterService.parseFiltersFromQueryParams({
    }, filters);
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.activatedRoute.data
      .pipe(
        delay(0),
        first()
      )
      .subscribe((data: any) => {
        this.statusKey = this.statusKey ?? data.statusKey ?? null;
        if (!this.embeddedView) {
          this.store
            .pipe(
              select(getCurrentRouteState),
              delay(0),
              distinctUntilChanged((prev: RouterStateUrl, curr: RouterStateUrl) => prev.url === curr.url),
              takeUntil(this.destroyed$),
            )
            .subscribe((state: RouterStateUrl) => {
              this.parseFilters(state.params);
              this.paginator.pageIndex = state.params.page;
              this.paginator.pageSize = state.params.pageSize;
              this.loadListData();
            })
          ;
        } else {
          this.loadListData();
        }
      });
    this.paginator.page
      .pipe(
        takeUntil(this.destroyed$)
      ).subscribe((event: PageEvent) => {
      if (this.embeddedView) {
        this.loadListData();
      } else {
        this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
          page: event.pageIndex,
          pageSize: event.pageSize,
          ...this.filtersForm.value
        })]);
      }
    });

  }

  ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  buildFilters(): any {
    const filters = {...this.initialFilters};

    if (null !== this.receivablesBalanceId) {
      filters.receivablesBalanceUuid = this.receivablesBalanceId;
    }

    return filters;
  }

  async  loadListData():  Promise<void> {
    this.receivablesStatementService.loadList(
      this.paginator.pageIndex,
      this.paginator.pageSize,
      this.buildFilters(),
      );
  }

  filter(): void {
    if (this.embeddedView) {
      if (this.paginator.pageIndex === 0) {
        this.loadListData();
      } else {
        this.paginator.firstPage();
      }
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, this.filterService.parseFiltersToQueryParams({
        page: 0,
        pageSize: this.paginator.pageSize,
        ...this.filtersForm.value,
      })]);
    }
  }

  resetFilters(): void {
    this.filtersForm.resetForm();
    if (this.embeddedView) {
      this.loadListData();
    } else {
      this.router.navigate([this.activatedRoute.snapshot.routeConfig.path, {
        page: 0,
        pageSize: this.paginator.pageSize,
      }]);
    }
  }


  downloadReport(): void {
    this.receivablesStatementService.downloadReport(this.buildFilters())
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }

  wednesdayWeekRange(dateInput) {
    const date = (dateInput instanceof Date) ? new Date(dateInput) : new Date(dateInput);
    const d = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    const day = d.getDay(); // 0=Sun,...,3=Wed...
    const diffToWednesday = (day - 3 + 7) % 7; // ile dni cofnąć, aby osiągnąć środę (bieżącego tygodnia)
    const start = new Date(d);
    start.setDate(d.getDate() - diffToWednesday);

    start.setDate(start.getDate() - 7);


    start.setHours(0, 0, 0, 0);
    const end = new Date(start);
    end.setDate(start.getDate() + 6);
    end.setHours(23, 59, 59, 999);


    return { start, end };
  }

  buildFiltersHistory(): any {
    const filters = {...this.initialFiltersHistory};

    if (null !== this.receivablesBalanceId) {
      filters.receivablesBalanceUuid = this.receivablesBalanceId;
    }

    return filters;
  }

  downloadReportHistory( createdAt: string): void {
    const filters = {...this.initialFiltersHistory};

    filters.receivablesBalanceUuid = this.receivablesBalanceId;
    filters.createdAt = createdAt;

    this.receivablesStatementService.downloadReportHistory(filters)
      .subscribe((response: Uuid) => {
        this.dialog.open(JobResultDialogComponent, {
          disableClose: true,
          width: '500px',
          data: {jobId: response.uuid, showProgress: false},
        });
      }, (error: HttpErrorResponse) => {
        this.snack.open('Przy generowaniu raportu wystąpił błąd', error.status.toString(), {duration: 2000});
      });
  }
}
